import React from 'react';
import classnames from 'classnames';
import { CountryState } from 'types';

import { t, getTranslation } from 'components/Translate';
import Dropdown from 'components/Dropdown';
import { Subtitle } from 'components/Text';

import styles from './CountryStatePicker.module.scss';

type DropdownProps = GCP<Dropdown<CountryState>>;
type Props = {
  states: CountryState[],
  className?: string,
  selected: string | null,
  onChange: (code: CountryState) => void,
  size?: 'normal' | 'large',
};

// TODO: unify with CountryPicker
class CountryStatePicker extends React.Component<Props> {
  static defaultProps: OptionalProps<Props> = {
    size: 'large',
  };
  private onChange: DropdownProps['onChange'] = (item, hide) => {
    this.props.onChange(item);
    hide();
  };

  render() {
    const { selected, size, className, states } = this.props;

    return (
      <Dropdown<CountryState>
        className={ classnames('m-0', className) }
        items={ states }
        keyParam="id"
        selected={ selected }
        onChange={ this.onChange }
        renderSelected={ this.renderSelected }
        renderItem={ this.renderItem }
        search={ {
          enabled: true,
          filterBy: ({ code, name }) => [code, name].join(''),
          placeholder: getTranslation('common.label.search'),
        } }
        height={ 225 }
        size={ size }
      />
    );
  }
  private renderSelected: DropdownProps['renderSelected'] = (item) => {
    if (!item) {
      return (
        <Subtitle color="dark-light" type={ this.props.size === 'normal' ? 'small' : 'normal' }>
          { t('onboarding.signup.selectState') }
        </Subtitle>
      );
    }

    return (
      <Subtitle type={ this.props.size === 'normal' ? 'small' : 'normal' }>
        { item.name }
      </Subtitle>
    );
  };
  private renderItem: DropdownProps['renderItem'] = ({ key, item, onClick }) => (
    <li className={ styles.item } key={ key } onClick={ onClick }>
      <Subtitle type="small">
        { item.name }
      </Subtitle>
    </li>
  );
}

export default CountryStatePicker;
